/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as FirstRunRouteImport } from './routes/first-run'
import { Route as KitRouteImport } from './routes/kit'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppMainRouteImport } from './routes/_app/_main'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as ConnectOpenrouterRouteImport } from './routes/connect.openrouter'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as AppMainHomeRouteImport } from './routes/_app/_main/home'
import { Route as AppMainNotebookRouteImport } from './routes/_app/_main/notebook'
import { Route as AppMainTasksRouteImport } from './routes/_app/_main/tasks'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings.billing'
import { Route as AppSettingsConnectionsRouteImport } from './routes/_app/settings.connections'
import { Route as AppSettingsDesktopRouteImport } from './routes/_app/settings.desktop'
import { Route as AppSettingsInsightsRouteImport } from './routes/_app/settings.insights'
import { Route as AppSettingsMachinesRouteImport } from './routes/_app/settings.machines'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings.members'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings.notifications'
import { Route as AppSettingsOrgRouteImport } from './routes/_app/settings.org'
import { Route as AppSettingsPlaybooksRouteImport } from './routes/_app/settings.playbooks'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings.profile'
import { Route as AppSettingsSkillsRouteImport } from './routes/_app/settings.skills'
import { Route as AppMainChatIndexRouteImport } from './routes/_app/_main/chat.index'
import { Route as AppMainChatRoomIdRouteImport } from './routes/_app/_main/chat.$roomId'
import { Route as AppMainCodeBranchIdRouteImport } from './routes/_app/_main/code.$branchId'
import { Route as AppMainTeamIndexRouteImport } from './routes/_app/_main/team.index'
import { Route as AppMainTeamEmployeeIdRouteImport } from './routes/_app/_main/team.$employeeId'
import { Route as AppMainTeamEmployeeIdIndexRouteImport } from './routes/_app/_main/team.$employeeId.index'
import { Route as AppMainTeamEmployeeIdActivityRouteImport } from './routes/_app/_main/team.$employeeId.activity'
import { Route as AppMainTeamEmployeeIdBudgetRouteImport } from './routes/_app/_main/team.$employeeId.budget'
import { Route as AppMainTeamEmployeeIdMemoryRouteImport } from './routes/_app/_main/team.$employeeId.memory'
import { Route as AppMainTeamEmployeeIdRoutinesRouteImport } from './routes/_app/_main/team.$employeeId.routines'
import { Route as AppMainTeamEmployeeIdRulesRouteImport } from './routes/_app/_main/team.$employeeId.rules'
import { Route as AppMainTeamEmployeeIdSkillsRouteImport } from './routes/_app/_main/team.$employeeId.skills'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const FirstRunRoute = FirstRunRouteImport.update({
  id: '/first-run',
  path: '/first-run',
  getParentRoute: () => rootRouteImport,
} as any)
const KitRoute = KitRouteImport.update({
  id: '/kit',
  path: '/kit',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMainRoute = AppMainRouteImport.update({
  id: '/_main',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const ConnectOpenrouterRoute = ConnectOpenrouterRouteImport.update({
  id: '/connect/openrouter',
  path: '/connect/openrouter',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
  id: '/invite/$invitationId',
  path: '/invite/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMainHomeRoute = AppMainHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppMainRoute,
} as any)
const AppMainNotebookRoute = AppMainNotebookRouteImport.update({
  id: '/notebook',
  path: '/notebook',
  getParentRoute: () => AppMainRoute,
} as any)
const AppMainTasksRoute = AppMainTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppMainRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsConnectionsRoute = AppSettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDesktopRoute = AppSettingsDesktopRouteImport.update({
  id: '/desktop',
  path: '/desktop',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsInsightsRoute = AppSettingsInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMachinesRoute = AppSettingsMachinesRouteImport.update({
  id: '/machines',
  path: '/machines',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsOrgRoute = AppSettingsOrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPlaybooksRoute = AppSettingsPlaybooksRouteImport.update({
  id: '/playbooks',
  path: '/playbooks',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSkillsRoute = AppSettingsSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppMainChatIndexRoute = AppMainChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AppMainRoute,
} as any)
const AppMainChatRoomIdRoute = AppMainChatRoomIdRouteImport.update({
  id: '/chat/$roomId',
  path: '/chat/$roomId',
  getParentRoute: () => AppMainRoute,
} as any)
const AppMainCodeBranchIdRoute = AppMainCodeBranchIdRouteImport.update({
  id: '/code/$branchId',
  path: '/code/$branchId',
  getParentRoute: () => AppMainRoute,
} as any)
const AppMainTeamIndexRoute = AppMainTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AppMainRoute,
} as any)
const AppMainTeamEmployeeIdRoute = AppMainTeamEmployeeIdRouteImport.update({
  id: '/team/$employeeId',
  path: '/team/$employeeId',
  getParentRoute: () => AppMainRoute,
} as any)
const AppMainTeamEmployeeIdIndexRoute =
  AppMainTeamEmployeeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppMainTeamEmployeeIdRoute,
  } as any)
const AppMainTeamEmployeeIdActivityRoute =
  AppMainTeamEmployeeIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AppMainTeamEmployeeIdRoute,
  } as any)
const AppMainTeamEmployeeIdBudgetRoute =
  AppMainTeamEmployeeIdBudgetRouteImport.update({
    id: '/budget',
    path: '/budget',
    getParentRoute: () => AppMainTeamEmployeeIdRoute,
  } as any)
const AppMainTeamEmployeeIdMemoryRoute =
  AppMainTeamEmployeeIdMemoryRouteImport.update({
    id: '/memory',
    path: '/memory',
    getParentRoute: () => AppMainTeamEmployeeIdRoute,
  } as any)
const AppMainTeamEmployeeIdRoutinesRoute =
  AppMainTeamEmployeeIdRoutinesRouteImport.update({
    id: '/routines',
    path: '/routines',
    getParentRoute: () => AppMainTeamEmployeeIdRoute,
  } as any)
const AppMainTeamEmployeeIdRulesRoute =
  AppMainTeamEmployeeIdRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => AppMainTeamEmployeeIdRoute,
  } as any)
const AppMainTeamEmployeeIdSkillsRoute =
  AppMainTeamEmployeeIdSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => AppMainTeamEmployeeIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/first-run': typeof FirstRunRoute
  '/kit': typeof KitRoute
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/connect/openrouter': typeof ConnectOpenrouterRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/home': typeof AppMainHomeRoute
  '/notebook': typeof AppMainNotebookRoute
  '/tasks': typeof AppMainTasksRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/connections': typeof AppSettingsConnectionsRoute
  '/settings/desktop': typeof AppSettingsDesktopRoute
  '/settings/insights': typeof AppSettingsInsightsRoute
  '/settings/machines': typeof AppSettingsMachinesRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/org': typeof AppSettingsOrgRoute
  '/settings/playbooks': typeof AppSettingsPlaybooksRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/skills': typeof AppSettingsSkillsRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/chat/$roomId': typeof AppMainChatRoomIdRoute
  '/code/$branchId': typeof AppMainCodeBranchIdRoute
  '/team/$employeeId': typeof AppMainTeamEmployeeIdRouteWithChildren
  '/chat/': typeof AppMainChatIndexRoute
  '/team/': typeof AppMainTeamIndexRoute
  '/team/$employeeId/activity': typeof AppMainTeamEmployeeIdActivityRoute
  '/team/$employeeId/budget': typeof AppMainTeamEmployeeIdBudgetRoute
  '/team/$employeeId/memory': typeof AppMainTeamEmployeeIdMemoryRoute
  '/team/$employeeId/routines': typeof AppMainTeamEmployeeIdRoutinesRoute
  '/team/$employeeId/rules': typeof AppMainTeamEmployeeIdRulesRoute
  '/team/$employeeId/skills': typeof AppMainTeamEmployeeIdSkillsRoute
  '/team/$employeeId/': typeof AppMainTeamEmployeeIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/first-run': typeof FirstRunRoute
  '/kit': typeof KitRoute
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/connect/openrouter': typeof ConnectOpenrouterRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/home': typeof AppMainHomeRoute
  '/notebook': typeof AppMainNotebookRoute
  '/tasks': typeof AppMainTasksRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/connections': typeof AppSettingsConnectionsRoute
  '/settings/desktop': typeof AppSettingsDesktopRoute
  '/settings/insights': typeof AppSettingsInsightsRoute
  '/settings/machines': typeof AppSettingsMachinesRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/org': typeof AppSettingsOrgRoute
  '/settings/playbooks': typeof AppSettingsPlaybooksRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/skills': typeof AppSettingsSkillsRoute
  '/settings': typeof AppSettingsIndexRoute
  '/chat/$roomId': typeof AppMainChatRoomIdRoute
  '/code/$branchId': typeof AppMainCodeBranchIdRoute
  '/chat': typeof AppMainChatIndexRoute
  '/team': typeof AppMainTeamIndexRoute
  '/team/$employeeId/activity': typeof AppMainTeamEmployeeIdActivityRoute
  '/team/$employeeId/budget': typeof AppMainTeamEmployeeIdBudgetRoute
  '/team/$employeeId/memory': typeof AppMainTeamEmployeeIdMemoryRoute
  '/team/$employeeId/routines': typeof AppMainTeamEmployeeIdRoutinesRoute
  '/team/$employeeId/rules': typeof AppMainTeamEmployeeIdRulesRoute
  '/team/$employeeId/skills': typeof AppMainTeamEmployeeIdSkillsRoute
  '/team/$employeeId': typeof AppMainTeamEmployeeIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/first-run': typeof FirstRunRoute
  '/kit': typeof KitRoute
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/_app/_main': typeof AppMainRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/connect/openrouter': typeof ConnectOpenrouterRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/_app/_main/home': typeof AppMainHomeRoute
  '/_app/_main/notebook': typeof AppMainNotebookRoute
  '/_app/_main/tasks': typeof AppMainTasksRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/connections': typeof AppSettingsConnectionsRoute
  '/_app/settings/desktop': typeof AppSettingsDesktopRoute
  '/_app/settings/insights': typeof AppSettingsInsightsRoute
  '/_app/settings/machines': typeof AppSettingsMachinesRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/org': typeof AppSettingsOrgRoute
  '/_app/settings/playbooks': typeof AppSettingsPlaybooksRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/skills': typeof AppSettingsSkillsRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/_main/chat/$roomId': typeof AppMainChatRoomIdRoute
  '/_app/_main/code/$branchId': typeof AppMainCodeBranchIdRoute
  '/_app/_main/team/$employeeId': typeof AppMainTeamEmployeeIdRouteWithChildren
  '/_app/_main/chat/': typeof AppMainChatIndexRoute
  '/_app/_main/team/': typeof AppMainTeamIndexRoute
  '/_app/_main/team/$employeeId/activity': typeof AppMainTeamEmployeeIdActivityRoute
  '/_app/_main/team/$employeeId/budget': typeof AppMainTeamEmployeeIdBudgetRoute
  '/_app/_main/team/$employeeId/memory': typeof AppMainTeamEmployeeIdMemoryRoute
  '/_app/_main/team/$employeeId/routines': typeof AppMainTeamEmployeeIdRoutinesRoute
  '/_app/_main/team/$employeeId/rules': typeof AppMainTeamEmployeeIdRulesRoute
  '/_app/_main/team/$employeeId/skills': typeof AppMainTeamEmployeeIdSkillsRoute
  '/_app/_main/team/$employeeId/': typeof AppMainTeamEmployeeIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/first-run'
    | '/kit'
    | '/setup'
    | '/sign-in'
    | '/settings'
    | '/connect/openrouter'
    | '/invite/$invitationId'
    | '/home'
    | '/notebook'
    | '/tasks'
    | '/settings/billing'
    | '/settings/connections'
    | '/settings/desktop'
    | '/settings/insights'
    | '/settings/machines'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/org'
    | '/settings/playbooks'
    | '/settings/profile'
    | '/settings/skills'
    | '/settings/'
    | '/chat/$roomId'
    | '/code/$branchId'
    | '/team/$employeeId'
    | '/chat/'
    | '/team/'
    | '/team/$employeeId/activity'
    | '/team/$employeeId/budget'
    | '/team/$employeeId/memory'
    | '/team/$employeeId/routines'
    | '/team/$employeeId/rules'
    | '/team/$employeeId/skills'
    | '/team/$employeeId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/first-run'
    | '/kit'
    | '/setup'
    | '/sign-in'
    | '/connect/openrouter'
    | '/invite/$invitationId'
    | '/home'
    | '/notebook'
    | '/tasks'
    | '/settings/billing'
    | '/settings/connections'
    | '/settings/desktop'
    | '/settings/insights'
    | '/settings/machines'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/org'
    | '/settings/playbooks'
    | '/settings/profile'
    | '/settings/skills'
    | '/settings'
    | '/chat/$roomId'
    | '/code/$branchId'
    | '/chat'
    | '/team'
    | '/team/$employeeId/activity'
    | '/team/$employeeId/budget'
    | '/team/$employeeId/memory'
    | '/team/$employeeId/routines'
    | '/team/$employeeId/rules'
    | '/team/$employeeId/skills'
    | '/team/$employeeId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/first-run'
    | '/kit'
    | '/setup'
    | '/sign-in'
    | '/_app/_main'
    | '/_app/settings'
    | '/connect/openrouter'
    | '/invite/$invitationId'
    | '/_app/_main/home'
    | '/_app/_main/notebook'
    | '/_app/_main/tasks'
    | '/_app/settings/billing'
    | '/_app/settings/connections'
    | '/_app/settings/desktop'
    | '/_app/settings/insights'
    | '/_app/settings/machines'
    | '/_app/settings/members'
    | '/_app/settings/notifications'
    | '/_app/settings/org'
    | '/_app/settings/playbooks'
    | '/_app/settings/profile'
    | '/_app/settings/skills'
    | '/_app/settings/'
    | '/_app/_main/chat/$roomId'
    | '/_app/_main/code/$branchId'
    | '/_app/_main/team/$employeeId'
    | '/_app/_main/chat/'
    | '/_app/_main/team/'
    | '/_app/_main/team/$employeeId/activity'
    | '/_app/_main/team/$employeeId/budget'
    | '/_app/_main/team/$employeeId/memory'
    | '/_app/_main/team/$employeeId/routines'
    | '/_app/_main/team/$employeeId/rules'
    | '/_app/_main/team/$employeeId/skills'
    | '/_app/_main/team/$employeeId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  FirstRunRoute: typeof FirstRunRoute
  KitRoute: typeof KitRoute
  SetupRoute: typeof SetupRoute
  SignInRoute: typeof SignInRoute
  ConnectOpenrouterRoute: typeof ConnectOpenrouterRoute
  InviteInvitationIdRoute: typeof InviteInvitationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/first-run': {
      id: '/first-run'
      path: '/first-run'
      fullPath: '/first-run'
      preLoaderRoute: typeof FirstRunRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kit': {
      id: '/kit'
      path: '/kit'
      fullPath: '/kit'
      preLoaderRoute: typeof KitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_main': {
      id: '/_app/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppMainRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/connect/openrouter': {
      id: '/connect/openrouter'
      path: '/connect/openrouter'
      fullPath: '/connect/openrouter'
      preLoaderRoute: typeof ConnectOpenrouterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$invitationId': {
      id: '/invite/$invitationId'
      path: '/invite/$invitationId'
      fullPath: '/invite/$invitationId'
      preLoaderRoute: typeof InviteInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_main/home': {
      id: '/_app/_main/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppMainHomeRouteImport
      parentRoute: typeof AppMainRoute
    }
    '/_app/_main/notebook': {
      id: '/_app/_main/notebook'
      path: '/notebook'
      fullPath: '/notebook'
      preLoaderRoute: typeof AppMainNotebookRouteImport
      parentRoute: typeof AppMainRoute
    }
    '/_app/_main/tasks': {
      id: '/_app/_main/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppMainTasksRouteImport
      parentRoute: typeof AppMainRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/connections': {
      id: '/_app/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof AppSettingsConnectionsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/desktop': {
      id: '/_app/settings/desktop'
      path: '/desktop'
      fullPath: '/settings/desktop'
      preLoaderRoute: typeof AppSettingsDesktopRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/insights': {
      id: '/_app/settings/insights'
      path: '/insights'
      fullPath: '/settings/insights'
      preLoaderRoute: typeof AppSettingsInsightsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/machines': {
      id: '/_app/settings/machines'
      path: '/machines'
      fullPath: '/settings/machines'
      preLoaderRoute: typeof AppSettingsMachinesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/org': {
      id: '/_app/settings/org'
      path: '/org'
      fullPath: '/settings/org'
      preLoaderRoute: typeof AppSettingsOrgRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/playbooks': {
      id: '/_app/settings/playbooks'
      path: '/playbooks'
      fullPath: '/settings/playbooks'
      preLoaderRoute: typeof AppSettingsPlaybooksRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/skills': {
      id: '/_app/settings/skills'
      path: '/skills'
      fullPath: '/settings/skills'
      preLoaderRoute: typeof AppSettingsSkillsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/_main/chat/': {
      id: '/_app/_main/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof AppMainChatIndexRouteImport
      parentRoute: typeof AppMainRoute
    }
    '/_app/_main/chat/$roomId': {
      id: '/_app/_main/chat/$roomId'
      path: '/chat/$roomId'
      fullPath: '/chat/$roomId'
      preLoaderRoute: typeof AppMainChatRoomIdRouteImport
      parentRoute: typeof AppMainRoute
    }
    '/_app/_main/code/$branchId': {
      id: '/_app/_main/code/$branchId'
      path: '/code/$branchId'
      fullPath: '/code/$branchId'
      preLoaderRoute: typeof AppMainCodeBranchIdRouteImport
      parentRoute: typeof AppMainRoute
    }
    '/_app/_main/team/': {
      id: '/_app/_main/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof AppMainTeamIndexRouteImport
      parentRoute: typeof AppMainRoute
    }
    '/_app/_main/team/$employeeId': {
      id: '/_app/_main/team/$employeeId'
      path: '/team/$employeeId'
      fullPath: '/team/$employeeId'
      preLoaderRoute: typeof AppMainTeamEmployeeIdRouteImport
      parentRoute: typeof AppMainRoute
    }
    '/_app/_main/team/$employeeId/': {
      id: '/_app/_main/team/$employeeId/'
      path: '/'
      fullPath: '/team/$employeeId/'
      preLoaderRoute: typeof AppMainTeamEmployeeIdIndexRouteImport
      parentRoute: typeof AppMainTeamEmployeeIdRoute
    }
    '/_app/_main/team/$employeeId/activity': {
      id: '/_app/_main/team/$employeeId/activity'
      path: '/activity'
      fullPath: '/team/$employeeId/activity'
      preLoaderRoute: typeof AppMainTeamEmployeeIdActivityRouteImport
      parentRoute: typeof AppMainTeamEmployeeIdRoute
    }
    '/_app/_main/team/$employeeId/budget': {
      id: '/_app/_main/team/$employeeId/budget'
      path: '/budget'
      fullPath: '/team/$employeeId/budget'
      preLoaderRoute: typeof AppMainTeamEmployeeIdBudgetRouteImport
      parentRoute: typeof AppMainTeamEmployeeIdRoute
    }
    '/_app/_main/team/$employeeId/memory': {
      id: '/_app/_main/team/$employeeId/memory'
      path: '/memory'
      fullPath: '/team/$employeeId/memory'
      preLoaderRoute: typeof AppMainTeamEmployeeIdMemoryRouteImport
      parentRoute: typeof AppMainTeamEmployeeIdRoute
    }
    '/_app/_main/team/$employeeId/routines': {
      id: '/_app/_main/team/$employeeId/routines'
      path: '/routines'
      fullPath: '/team/$employeeId/routines'
      preLoaderRoute: typeof AppMainTeamEmployeeIdRoutinesRouteImport
      parentRoute: typeof AppMainTeamEmployeeIdRoute
    }
    '/_app/_main/team/$employeeId/rules': {
      id: '/_app/_main/team/$employeeId/rules'
      path: '/rules'
      fullPath: '/team/$employeeId/rules'
      preLoaderRoute: typeof AppMainTeamEmployeeIdRulesRouteImport
      parentRoute: typeof AppMainTeamEmployeeIdRoute
    }
    '/_app/_main/team/$employeeId/skills': {
      id: '/_app/_main/team/$employeeId/skills'
      path: '/skills'
      fullPath: '/team/$employeeId/skills'
      preLoaderRoute: typeof AppMainTeamEmployeeIdSkillsRouteImport
      parentRoute: typeof AppMainTeamEmployeeIdRoute
    }
  }
}

interface AppMainTeamEmployeeIdRouteChildren {
  AppMainTeamEmployeeIdActivityRoute: typeof AppMainTeamEmployeeIdActivityRoute
  AppMainTeamEmployeeIdBudgetRoute: typeof AppMainTeamEmployeeIdBudgetRoute
  AppMainTeamEmployeeIdMemoryRoute: typeof AppMainTeamEmployeeIdMemoryRoute
  AppMainTeamEmployeeIdRoutinesRoute: typeof AppMainTeamEmployeeIdRoutinesRoute
  AppMainTeamEmployeeIdRulesRoute: typeof AppMainTeamEmployeeIdRulesRoute
  AppMainTeamEmployeeIdSkillsRoute: typeof AppMainTeamEmployeeIdSkillsRoute
  AppMainTeamEmployeeIdIndexRoute: typeof AppMainTeamEmployeeIdIndexRoute
}

const AppMainTeamEmployeeIdRouteChildren: AppMainTeamEmployeeIdRouteChildren = {
  AppMainTeamEmployeeIdActivityRoute: AppMainTeamEmployeeIdActivityRoute,
  AppMainTeamEmployeeIdBudgetRoute: AppMainTeamEmployeeIdBudgetRoute,
  AppMainTeamEmployeeIdMemoryRoute: AppMainTeamEmployeeIdMemoryRoute,
  AppMainTeamEmployeeIdRoutinesRoute: AppMainTeamEmployeeIdRoutinesRoute,
  AppMainTeamEmployeeIdRulesRoute: AppMainTeamEmployeeIdRulesRoute,
  AppMainTeamEmployeeIdSkillsRoute: AppMainTeamEmployeeIdSkillsRoute,
  AppMainTeamEmployeeIdIndexRoute: AppMainTeamEmployeeIdIndexRoute,
}

const AppMainTeamEmployeeIdRouteWithChildren =
  AppMainTeamEmployeeIdRoute._addFileChildren(
    AppMainTeamEmployeeIdRouteChildren,
  )

interface AppMainRouteChildren {
  AppMainHomeRoute: typeof AppMainHomeRoute
  AppMainNotebookRoute: typeof AppMainNotebookRoute
  AppMainTasksRoute: typeof AppMainTasksRoute
  AppMainChatRoomIdRoute: typeof AppMainChatRoomIdRoute
  AppMainCodeBranchIdRoute: typeof AppMainCodeBranchIdRoute
  AppMainTeamEmployeeIdRoute: typeof AppMainTeamEmployeeIdRouteWithChildren
  AppMainChatIndexRoute: typeof AppMainChatIndexRoute
  AppMainTeamIndexRoute: typeof AppMainTeamIndexRoute
}

const AppMainRouteChildren: AppMainRouteChildren = {
  AppMainHomeRoute: AppMainHomeRoute,
  AppMainNotebookRoute: AppMainNotebookRoute,
  AppMainTasksRoute: AppMainTasksRoute,
  AppMainChatRoomIdRoute: AppMainChatRoomIdRoute,
  AppMainCodeBranchIdRoute: AppMainCodeBranchIdRoute,
  AppMainTeamEmployeeIdRoute: AppMainTeamEmployeeIdRouteWithChildren,
  AppMainChatIndexRoute: AppMainChatIndexRoute,
  AppMainTeamIndexRoute: AppMainTeamIndexRoute,
}

const AppMainRouteWithChildren =
  AppMainRoute._addFileChildren(AppMainRouteChildren)

interface AppSettingsRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsConnectionsRoute: typeof AppSettingsConnectionsRoute
  AppSettingsDesktopRoute: typeof AppSettingsDesktopRoute
  AppSettingsInsightsRoute: typeof AppSettingsInsightsRoute
  AppSettingsMachinesRoute: typeof AppSettingsMachinesRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsOrgRoute: typeof AppSettingsOrgRoute
  AppSettingsPlaybooksRoute: typeof AppSettingsPlaybooksRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsSkillsRoute: typeof AppSettingsSkillsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsConnectionsRoute: AppSettingsConnectionsRoute,
  AppSettingsDesktopRoute: AppSettingsDesktopRoute,
  AppSettingsInsightsRoute: AppSettingsInsightsRoute,
  AppSettingsMachinesRoute: AppSettingsMachinesRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsOrgRoute: AppSettingsOrgRoute,
  AppSettingsPlaybooksRoute: AppSettingsPlaybooksRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSkillsRoute: AppSettingsSkillsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppMainRoute: typeof AppMainRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppMainRoute: AppMainRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  FirstRunRoute: FirstRunRoute,
  KitRoute: KitRoute,
  SetupRoute: SetupRoute,
  SignInRoute: SignInRoute,
  ConnectOpenrouterRoute: ConnectOpenrouterRoute,
  InviteInvitationIdRoute: InviteInvitationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
